import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Switch from "components/Switch";
import Select from "react-select";
import {connect} from "react-redux";

class TabMatrixDropdown extends PureComponent {

  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
  }

  onChange(key, value) {
    let data = this.props.data.survey.questionSettings.matrixDropdown;
    data[key] = value;

    this.props.onChangeQuestionSettings('matrixDropdown', data);
  }

  render() {
    const {errors, data, questionConfig} = this.props;

    return (
      <React.Fragment>
        <FormGroup>
          <Label for="rotateAnswers"><FormattedMessage id="_.question.matrixDropdown.rotateAnswers" /></Label>
          <Switch stickToProp checked={data.survey.questionSettings.matrixDropdown.rotateAnswers} onChange={value => this.onChange('rotateAnswers', value)} />
        </FormGroup>
        <FormGroup>
          <Label><FormattedMessage id="_.question.matrixDropdown.presentationType" /></Label>
          <Select
            isMulti
            value={_.map(data.survey.questionSettings.matrixDropdown.presentationTypes, type => {
              return {
                label: <FormattedMessage id={'_.question.matrixDropdown.presentationType.' + type} />,
                value: type,
              }
            })}
            onChange={e => {
              this.onChange('presentationTypes', e.map(val => val.value))
            }}
            options={_.map(questionConfig.presentationTypes, type => {
              return {
                label: <FormattedMessage id={'_.question.matrixDropdown.presentationType.' + type} />,
                value: type,
              }
            })}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}


TabMatrixDropdown.propTypes = {
  data: PropTypes.shape({
    survey: PropTypes.shape({
      questionSettings: PropTypes.shape({
        matrixDropdown: PropTypes.object.isRequired,
      }).isRequired
    }).isRequired,
  }),
  errors: PropTypes.object.isRequired,
  onChangeQuestionSettings: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    questionConfig: state.config.data.questions.matrixDropdown
  }
}

export default connect(mapStateToProps)(TabMatrixDropdown);